import React from 'react'
import styled from 'styled-components'
import ErrorBoundary from '../errorBoundary'
import Modal from '../modal/loadable'
import { customModalStyle, mobileModalStyle } from './customModalStyle'
import { Desktop, Tablet, SmallMobile } from '../../utils/displayResponsive'
import { Box } from '../styledComponents'
import { useWindowSize } from 'react-use'
import { ModalResize } from 'utils/commaize'

const Container = styled(Box)`
  max-width: 450px;
  text-align: center;
  img {
    margin-top: 67px;
  }
  p {
    font-size: 24px;
  }
  p + p {
    font-size: 14px;
  }
  button {
    p {
      font-size: 16px;
      font-weight: 700px;
    }
    width: 185px;
    height: 48px;
  }

  @media (max-width: 426px) {
    max-width: 390px;
    img {
      margin-top: 24px;
    }
    button {
      p {
        margin-bottom: 0px;
      }
      width: 135px;
      height: 40px;
      border-radius: 10px;
    }
  }
`

const EnrollModal = ({ isOpen, onRequestClose, onAfterClose, onClickClose, children }) => {
  // const {
  //   isOpen,
  //   title,
  //   title2,
  //   titleId,
  //   subtitle,
  //   subtitleId,
  //   btn1,
  //   btn2,
  //   onRequestClose,
  //   onAfterClose,
  //   image,
  //   titleNoMargin,
  //   titleNoMarginId,
  //   windowWidth,
  //   windowHeight,
  // } = this.props
  // const landscape = windowHeight < windowWidth
  // const width = landscape ? '50vw' : '90vw'
  const { width } = useWindowSize()
  return (
    <ErrorBoundary>
      <Desktop>
        <Modal
          isOpen={isOpen}
          overlayStyle={customModalStyle.overlay}
          contentStyle={customModalStyle.content}
          onRequestClose={onRequestClose}
          onAfterClose={onAfterClose}
          onClickClose={onClickClose}
        >
          <Container>{children}</Container>
        </Modal>
      </Desktop>
      <Tablet>
        <Modal
          isOpen={isOpen}
          overlayStyle={customModalStyle.overlay}
          contentStyle={customModalStyle.content}
          onRequestClose={onRequestClose}
          onAfterClose={onAfterClose}
          onClickClose={onClickClose}
        >
          <Container>{children}</Container>
        </Modal>
      </Tablet>
      <SmallMobile>
        <Modal
          isOpen={isOpen}
          overlayStyle={mobileModalStyle.overlay}
          contentStyle={{ ...mobileModalStyle.content, width: ModalResize(width) }}
          onRequestClose={onRequestClose}
          onAfterClose={onAfterClose}
          onClickClose={onClickClose}
        >
          <Container>{children}</Container>
        </Modal>
      </SmallMobile>
    </ErrorBoundary>
  )
}

export default EnrollModal
